<template>
  <div class="shop-superuser">
    <div class="new-card">
      <div class="card-content">
        <p class="field-name has-text-left">Superuser</p>
        <div style="height: 12px" />
        <nav class="level is-mobile">
          <div class="level-item has-text-centered">
            <div @click="toggleWhitelabel">
              <p>
                <i class="far fa-snowflake fa-lg has-text-info" />
              </p>
              <p class="heading">Whitelabel</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div @click="$emit('brandStory')">
              <!-- <div> -->
              <p>
                <i class="fa fa-laptop fa-lg has-text-info" />
              </p>
              <p class="heading">Desktop</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div @click="gotoBusinessProfile">
              <p>
                <i class="fa fa-pen fa-lg has-text-info" />
              </p>
              <p class="heading">Edit</p>
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div @click="gotoCommerceHome">
              <p>
                <i class="fa fa-home fa-lg has-text-info" />
              </p>
              <p class="heading">Commerce</p>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopSuperuser",
  components: {},
  props: {
    isWhiteLabel: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    business() {
      return this.$store.state.selectedBusiness;
    },
  },
  mounted() {},
  methods: {
    toggleWhitelabel() {
      if (this.isWhiteLabel) {
        this.goto("/shop/" + this.business.id);
      } else {
        this.goto("/shop/" + this.business.id + "?white_label=true");
      }
      this.refreshPage();
    },
    gotoBusinessProfile() {
      this.$router.push(`/business_profile/${this.business.id}`);
    },
    gotoCommerceHome() {
      this.goto(`/commerce_home/${this.business.id}`);
    },
  },
};
</script>

<style scoped>
.field-name {
  padding-bottom: 5px;
  line-height: 0pt;
  font-size: 0.8em;
  opacity: 0.6;
}
.new-card {
  overflow-x: hidden;
  background-color: white;
  margin-top: 2px;
}
.card-content {
  padding: 12px;
}
.fa-lg:active {
  transform: scaleY(0.95);
}
.level {
  margin-bottom: 0;
}
.fa-lg {
  font-size: 1.6em;
}
</style>